// Taboola Coupon System - Correct Flow

// Add CSS styles for taboola discount reminder
const taboolaStyles = `
.taboola-discount-reminder-wrapper{
    margin: 0 auto;
    display: flex;
    flex-direction: row; 
    align-items: center; 
    justify-content: center; 
    gap: 20px;
    text-align: left;
}

.taboola-discount-reminder-inner{
    display: flex; 
    flex-direction: row;
    justify-content: center; 
    font-size: 14px; opacity: 0.9;
}

.taboola-discount-reminder-inner .taboola-discount-reminder-main-text{
}

.taboola-discount-reminder-inner .taboola-discount-reminder-main-text strong{
}

.taboola-discount-reminder-inner .taboola-discount-reminder-main-discount-code{
    margin-left: 12px; 
    color: #ffbf00;
}

.taboola-discount-reminder-close-button{
    padding: 5px 10px;
    background: rgba(255,255,255,0.2); 
    border: none; color: white;
    border-radius: 3px; 
    cursor: pointer;
}

@media (max-width: 1180px) {

    .taboola-discount-reminder-inner{
        flex-direction: column;
        text-align: left;
    }

    .taboola-discount-reminder-inner .taboola-discount-reminder-main-discount-code {
        margin-left: 0;
    }

}

@media (max-width: 820px) {

}
`;

// Inject styles into the document
const styleSheet = document.createElement("style");
styleSheet.textContent = taboolaStyles;
document.head.appendChild(styleSheet);

(function() {
    let isProcessing = false;

    // Check if user came from Taboola
    function isTaboolaVisitor() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.has('taboola');
    }

    // Add discount parameter to any URL
    function addDiscountToUrl(url, discountCode) {
        try {
            const urlObj = new URL(url, window.location.origin);
            urlObj.searchParams.set('discount', discountCode);
            return urlObj.toString();
        } catch (error) {
            // Fallback for relative URLs
            const separator = url.includes('?') ? '&' : '?';
            return `${url}${separator}discount=${encodeURIComponent(discountCode)}`;
        }
    }

    // Apply coupon code to cart
    async function applyCouponToCart(couponCode) {
        console.log('🎯 Applying coupon to cart:', couponCode);
        
        try {
            // Method 1: Store in cart attributes
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    attributes: { 
                        'discount_code': couponCode,
                        '_discount': couponCode,
                        'taboola_coupon': couponCode,
                        'checkout_discount': couponCode
                    }
                })
            });

            // Method 2: Try direct discount application
            try {
                await fetch(`/discount/${couponCode}`, {
                    method: 'GET',
                    redirect: 'manual'
                });
            } catch (e) {
                console.log('Direct discount method attempted');
            }

            console.log('✅ Coupon applied to cart successfully');
            return true;
            
        } catch (error) {
            console.error('❌ Error applying coupon to cart:', error);
            return false;
        }
    }

    // Handle Taboola button click
    async function handleTaboolaButtonClick(button, redirectUrl) {
        if (isProcessing) return;
        isProcessing = true;

        console.log('🎯 Processing Taboola button click...');
        
        // Show loading state
        const originalText = button.textContent;
        button.textContent = 'Applying coupon...';
        button.style.pointerEvents = 'none';

        try {
            // Step 1: Apply coupon to cart
            console.log('📝 Step 1: Applying coupon to cart...');
            const couponApplied = await applyCouponToCart('taboolaSPECIAL20');
            
            if (couponApplied) {
                button.textContent = 'Coupon applied! Redirecting...';
                
                // Step 2: Wait a moment for the coupon to process
                console.log('⏳ Step 2: Waiting for coupon to process...');
                await new Promise(resolve => setTimeout(resolve, 1000));
                
                // Step 3: Redirect to the href with discount parameter as backup
                console.log('🔄 Step 3: Redirecting to:', redirectUrl);
                const urlWithDiscount = addDiscountToUrl(redirectUrl, 'taboolaSPECIAL20');
                
                // Analytics tracking
                if (typeof gtag !== 'undefined') {
                    gtag('event', 'taboola_coupon_applied', {
                        'event_category': 'taboola_campaign',
                        'event_label': 'coupon_applied_and_redirected',
                        'redirect_url': redirectUrl
                    });
                }
                
                window.location.href = urlWithDiscount;
            } else {
                // If coupon application failed, still redirect with URL parameter
                console.log('⚠️ Coupon application failed, redirecting with URL parameter...');
                button.textContent = 'Redirecting...';
                const urlWithDiscount = addDiscountToUrl(redirectUrl, 'taboolaSPECIAL20');
                window.location.href = urlWithDiscount;
            }
            
        } catch (error) {
            console.error('❌ Error in Taboola button handling:', error);
            // Fallback: redirect with discount in URL
            const urlWithDiscount = addDiscountToUrl(redirectUrl, 'taboolaSPECIAL20');
            window.location.href = urlWithDiscount;
        } finally {
            // Reset button state (though user will be redirected)
            isProcessing = false;
        }
    }

    // Setup checkout button interception for pages with coupon in URL
    function interceptCheckoutButtons() {
        const urlParams = new URLSearchParams(window.location.search);
        const discountCode = urlParams.get('discount');
        
        if (!discountCode) return;

        console.log('🔗 Setting up checkout interception for discount:', discountCode);

        const checkoutSelectors = [
            '#checkout',
            '[href="/checkout"]',
            '[href*="checkout"]',
            '.checkout-button',
            '[data-checkout]',
            'button[name="goto_pp"]',
            'button[name="goto_gc"]',
            '[data-shopify="payment-button"]',
            '.shopify-payment-button__button'
        ];

        checkoutSelectors.forEach(selector => {
            const buttons = document.querySelectorAll(selector);
            buttons.forEach(button => {
                if (button.dataset.taboolaProcessed) return;
                button.dataset.taboolaProcessed = 'true';

                // For anchor tags, update href
                if (button.tagName.toLowerCase() === 'a') {
                    const originalHref = button.href || '/checkout';
                    button.href = addDiscountToUrl(originalHref, discountCode);
                    console.log('✅ Updated checkout link with discount');
                } else {
                    // For buttons, add click handler
                    button.addEventListener('click', function(e) {
                        e.preventDefault();
                        const checkoutUrl = `/checkout?discount=${encodeURIComponent(discountCode)}`;
                        console.log('🛒 Redirecting to checkout with discount');
                        window.location.href = checkoutUrl;
                    });
                }
            });
        });
    }

    // Show discount reminder banner
    function showDiscountReminder() {
        const urlParams = new URLSearchParams(window.location.search);
        const discountCode = urlParams.get('discount');
        
        if (!discountCode || document.querySelector('#taboola-discount-reminder')) return;

        const banner = document.createElement('div');
        banner.id = 'taboola-discount-reminder';
        banner.style.cssText = `
            background: linear-gradient(135deg, #870058, #9F3379);
            color: white;
            padding: 12px 20px;
            text-align: center;
            position: sticky;
            top: 0;
            z-index: 9999;
            box-shadow: 0 2px 10px rgba(0,0,0,0.2);
        `;
        banner.innerHTML = `
            <div class="taboola-discount-reminder-wrapper">
                <div class="taboola-discount-reminder-inner">
                    <span class="taboola-discount-reminder-main-text"><strong>Your 20% OFF discount is ready!</strong> Now you can add NAD+ Precursors to your cart.</span>
                    <div class="taboola-discount-reminder-main-discount-code">Code: <strong>${discountCode}</strong> will apply at checkout</div>
                </div>
                <button class="taboola-discount-reminder-close-button" onclick="this.parentElement.parentElement.remove()">×</button>
            </div>
        `;
        
        document.body.insertBefore(banner, document.body.firstChild);
    }

    // Main handler for Taboola visitors
    function handleTaboolaVisitor() {
        if (!isTaboolaVisitor()) {
            // Not a Taboola visitor, but check if they have discount in URL
            showDiscountReminder();
            interceptCheckoutButtons();
            return;
        }

        console.log('🎯 Taboola visitor detected!');

        // Add "show" class to ".landing-taboola" elements
        const taboolaElements = document.querySelectorAll('.landing-taboola');
        console.log(`📱 Found ${taboolaElements.length} .landing-taboola elements`);
        
        taboolaElements.forEach(element => {
            element.classList.add('show');
        });

        // Setup click handlers for Taboola links
        const taboolaLinks = document.querySelectorAll('.landing-taboola a');
        console.log(`🔗 Found ${taboolaLinks.length} Taboola links`);
        
        taboolaLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                
                const redirectUrl = this.getAttribute('href');
                
                if (!redirectUrl) {
                    console.error('❌ No href found on Taboola link');
                    return;
                }

                console.log('🎯 Taboola button clicked, processing...');
                handleTaboolaButtonClick(this, redirectUrl);
            });
        });

        // Analytics tracking for display
        if (typeof gtag !== 'undefined') {
            gtag('event', 'taboola_offer_displayed', {
                'event_category': 'taboola_campaign',
                'event_label': 'landing_taboola_shown',
                'elements_count': taboolaElements.length
            });
        }
    }

    // Initialize
    function initialize() {
        console.log('🚀 Initializing Taboola coupon system...');
        
        handleTaboolaVisitor();
        
        // Setup checkout interception if discount is in URL
        showDiscountReminder();
        interceptCheckoutButtons();
        
        // Re-run checkout interception periodically for dynamic content
        setInterval(() => {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('discount')) {
                interceptCheckoutButtons();
            }
        }, 5000);
        
        console.log('✅ Taboola system ready!');
    }

    // Start when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize);
    } else {
        initialize();
    }

})();